import Vue from 'vue'

function to2 (num) {
  return num.toString().padStart(2, '0')
}

Vue.filter('convertDate', function (timestamp) {
  let time = timestamp
  if (typeof timestamp !== 'number') {
    time = Number(timestamp)
  }
  const D = new Date(time)
  const year = D.getFullYear()
  if (!year) return ''

  const month = D.getMonth() + 1
  const date = D.getDate()
  return `${to2(date)}-${to2(month)}-${year}`
})

Vue.filter('vouchDate', function (timestamp) {
  const date = new Date(timestamp)
  const options = {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  }

  // 获取时间字符串
  let formattedDate = date.toLocaleString('en-GB', options)

  // 将 'am' 或 'pm' 替换为大写
  formattedDate = formattedDate.replace(/\b(am|pm)\b/g, function (match) {
    return match.toUpperCase()
  })

  return formattedDate
})

Vue.filter('fullData', function (timestamp) {
  let time = timestamp
  if (typeof timestamp !== 'number') {
    time = Number(timestamp)
  }
  const D = new Date(time)
  const year = D.getFullYear()
  if (!year) return ''

  const month = D.getMonth() + 1
  const date = D.getDate()
  const hours = D.getHours()
  const minutes = D.getMinutes()
  const seconds = D.getSeconds()
  return `${to2(date)}/${to2(month)}/${year} ${to2(hours)}:${to2(minutes)}:${to2(seconds)}`
})
